import { Action } from 'types/api/Action';
import { IconWrapper, Icon } from './Styled';
import testIcon from 'images/reminders/test.svg';
import inviteIcon from 'images/reminders/invite.svg';
import trainingIcon from 'images/reminders/training.svg';
import certificationIcon from 'images/reminders/certification.svg';
import reliabilityTest from 'images/reminders/reliability_test.svg';
import instantInsights from 'images/dashboard/instant-insights.svg';

interface ReminderIconProps {
  action: Action;
}

function ReminderIcon({ action }: ReminderIconProps) {
  switch (action.type) {
    case 'product_invitation':
      return (
        <IconWrapper>
          <Icon src={inviteIcon} alt="" />
        </IconWrapper>
      );
    case 'training_invite':
    case 'upcoming_training':
    case 'ongoing_training':
      return (
        <IconWrapper>
          <Icon src={trainingIcon} alt="" />
        </IconWrapper>
      );
    case 'active_test':
      return (
        <IconWrapper>
          <Icon src={testIcon} alt="" />
        </IconWrapper>
      );
    case 'reliability':
      return (
        <IconWrapper>
          <Icon src={reliabilityTest} alt="" />
        </IconWrapper>
      );
    case 'knowledge':
      return (
        <IconWrapper>
          <Icon src={reliabilityTest} alt="" />
        </IconWrapper>
      );
    case 'calibration':
      return (
        <IconWrapper>
          <Icon src={reliabilityTest} alt="" />
        </IconWrapper>
      );
    case 'expiring_certification':
      return (
        <IconWrapper>
          <Icon src={certificationIcon} alt="" />
        </IconWrapper>
      );
    case 'video_obs_report_ready':
      return (
        <IconWrapper>
          <Icon src={instantInsights} alt="" />
        </IconWrapper>
      );
    case 'video_obs_video_failed':
      return (
        <IconWrapper>
          <i className="w-12 h-12 text-ds-icon-negative fa-3x fa-solid fa-triangle-exclamation" />
        </IconWrapper>
      );
    default:
      return (
        <IconWrapper>
          <Icon src={inviteIcon} alt="" />
        </IconWrapper>
      );
  }
}

export default ReminderIcon;
